<template>
  <div
      @click="showPersonalDataWindow = true"
      class="profile-btn"
  >

    <div class="header-main__profile-btn-col">
      <div class="profile-btn-name">
        {{ profileInfo }}
      </div>
      <p class="profile-btn-type" :title="name">
        {{name}}
      </p>
    </div>
  </div>
</template>
<script setup>
import {ref} from "vue";

const showPersonalDataWindow = ref(false);

const props = defineProps({
  profileInfo: String,
  name: String,
})
</script>
<style scoped>
.profile-btn {
  max-width: 160px;
  margin-left: auto;
  cursor: pointer;
}

.profile-btn-name {
  color: #000;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-btn-type {
  width: 100px;
  color: #000;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  opacity: 0.5;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>